import { Alert, Box, Link, SpaceBetween, Spinner } from '@amzn/awsui-components-core';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useAttachmentDownloadPageViewModel } from './AttachmentDownloadPageViewModel';

function AttachmentDownloadPage() {
  const { contentId, attachmentId } = useParams<{ contentId: string; attachmentId: string }>();
  const { isLoading, isError, errorMessage, downloadUrl, filename } =
    useAttachmentDownloadPageViewModel(contentId, attachmentId);

  if (isLoading) {
    return (
      <Box padding="xl" textAlign="center">
        <SpaceBetween size="s" alignItems="center" direction="vertical">
          <Spinner size="large" />
          <Box variant="p">Preparing your download...</Box>
        </SpaceBetween>
      </Box>
    );
  }

  if (isError) {
    return (
      <Box padding="xl">
        <Alert type="error" header="Download failed">
          {errorMessage}
        </Alert>
      </Box>
    );
  }

  return (
    <Box padding="xl">
      <SpaceBetween size="s" direction="vertical">
        <Box variant="p">
          Your download{filename ? ` of "${filename}"` : ''} should have started. If it did not,{' '}
          <Link href={downloadUrl} external={false}>
            click here
          </Link>
          .
        </Box>
      </SpaceBetween>
    </Box>
  );
}

export { AttachmentDownloadPage };
